// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-backdrop {
  align-items: center;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
}

.about {
  background-color: var(--color-base-canvas-translucent);
  border: var(--border-elevated);
  color: var(--color-elevated-text);
  max-width: 40rem;
  padding: 2rem;
  text-align: left;
  z-index: 1000;
}
.about .about-content {
  max-height: 50vh;
  overflow-y: scroll;
  padding: 1.5rem 0.5rem;
}
.about .about-title {
  font-size: 1.4rem;
  text-align: center;
}
.about .about-title .product {
  display: inline;
}
.about .copyright {
  border-bottom: var(--border-elevated);
  font-size: 0.8rem;
  color: var(--color-base-text);
  padding-bottom: 1rem;
  text-align: center;
}
.about .previous .version {
  border-top: 1px solid var(--color-base-border);
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  opacity: 0.7;
}
.about .version-title {
  font-size: 1.2rem;
  font-weight: normal;
  margin: 0 0.5rem 0 0;
}
.about .version-details, .about .known-issues-list {
  list-style-type: disc;
  margin-left: 2rem;
}
.about .known-issues-title {
  font-size: 1.2rem;
  margin: 2rem 0 0 0;
  font-weight: normal;
}
.about .about-actions {
  border-top: var(--border-elevated);
  text-align: center;
}
.about .about-close-button {
  margin-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/style/panes/about.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,2BAAA;EACA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAAiB,MAAA;EAAQ,QAAA;EAAU,SAAA;EAAW,OAAA;EAC9C,YAAA;AAKF;;AAFA;EACE,sDAAA;EACA,8BAAA;EACA,iCAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAKF;AAHE;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;AAKJ;AAFE;EACE,iBAAA;EACA,kBAAA;AAIJ;AAFI;EACE,eAAA;AAIN;AAAE;EACE,qCAAA;EACA,iBAAA;EACA,6BAAA;EACA,oBAAA;EACA,kBAAA;AAEJ;AACE;EACE,8CAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AAEC;EACG,iBAAA;EACA,mBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,qBAAA;EACA,iBAAA;AADJ;AAIE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,kCAAA;EACA,kBAAA;AAHJ;AAME;EACE,gBAAA;AAJJ","sourcesContent":[".about-backdrop {\n  align-items: center;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  display: flex;\n  justify-content: center;\n  position: fixed; top: 0; right: 0; bottom: 0; left: 0;\n  z-index: 999;\n}\n\n.about {\n  background-color: var(--color-base-canvas-translucent);\n  border: var(--border-elevated);\n  color: var(--color-elevated-text);\n  max-width: 40rem;\n  padding: 2rem;\n  text-align: left;\n  z-index: 1000;\n\n  .about-content {\n    max-height: 50vh;\n    overflow-y: scroll;\n    padding: 1.5rem 0.5rem;\n  }\n\n  .about-title {\n    font-size: 1.4rem;\n    text-align: center;\n\n    .product {\n      display: inline;\n    }\n  }\n\n  .copyright {\n    border-bottom: var(--border-elevated);\n    font-size: 0.8rem;\n    color: var(--color-base-text);\n    padding-bottom: 1rem;\n    text-align: center;\n  }\n\n  .previous .version {\n    border-top: 1px solid var(--color-base-border);\n    margin-top: 1.5rem;\n    padding-top: 1.5rem;\n    opacity: 0.7;\n  }\n\n .version-title {\n    font-size: 1.2rem;\n    font-weight: normal;\n    margin: 0 0.5rem 0 0;\n  }\n\n  .version-details, .known-issues-list {\n    list-style-type: disc;\n    margin-left: 2rem;\n  }\n\n  .known-issues-title {\n    font-size: 1.2rem;\n    margin: 2rem 0 0 0;\n    font-weight: normal;\n  }\n\n  .about-actions {\n    border-top: var(--border-elevated);\n    text-align: center;\n  }\n\n  .about-close-button {\n    margin-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
